// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeatureFlagsScreen-module__font-s-10___gFfOf {
  font-size: 10px !important;
}

.FeatureFlagsScreen-module__font-s-12___NvfAf {
  font-size: 12px !important;
}

.FeatureFlagsScreen-module__font-s-13___rVf6z {
  font-size: 13px !important;
}

.FeatureFlagsScreen-module__font-s-14___S0bU2 {
  font-size: 14px !important;
}

.FeatureFlagsScreen-module__font-s-15___IYReO {
  font-size: 15px !important;
}

.FeatureFlagsScreen-module__font-s-16___lTG2S {
  font-size: 16px !important;
}

.FeatureFlagsScreen-module__font-s-18___lQnAO {
  font-size: 18px !important;
}

.FeatureFlagsScreen-module__font-s-20___xhJ8y {
  font-size: 20px !important;
}

.FeatureFlagsScreen-module__font-s-22___nBeKW {
  font-size: 22px !important;
}

.FeatureFlagsScreen-module__font-s-28___f0OKw {
  font-size: 28px !important;
}

.FeatureFlagsScreen-module__font-w-400___eevkE {
  font-weight: 400 !important;
}

.FeatureFlagsScreen-module__font-w-500___fmyhp {
  font-weight: 500 !important;
}

.FeatureFlagsScreen-module__font-w-600____Kkwe {
  font-weight: 600 !important;
}

.FeatureFlagsScreen-module__font-w-700___ofS4c {
  font-weight: 700 !important;
}

.FeatureFlagsScreen-module__p-5___gZBOy {
  padding: 5px !important;
}

.FeatureFlagsScreen-module__p-12___ywtnW {
  padding: 12px !important;
}

.FeatureFlagsScreen-module__p-16___zOLPi {
  padding: 16px !important;
}

.FeatureFlagsScreen-module__p-30___iZi_x {
  padding: 30px !important;
}

.FeatureFlagsScreen-module__p-b-0___hXbj_ {
  padding-bottom: 0 !important;
}

.FeatureFlagsScreen-module__p-b-5___G8CpD {
  padding-bottom: 5px !important;
}

.FeatureFlagsScreen-module__p-b-10___BBGZO {
  padding-bottom: 10px !important;
}

.FeatureFlagsScreen-module__p-b-12___TSAvn {
  padding-bottom: 12px !important;
}

.FeatureFlagsScreen-module__p-b-16___Bv6Kb {
  padding-bottom: 16px !important;
}

.FeatureFlagsScreen-module__p-b-18___iQ_Lw {
  padding-bottom: 18px !important;
}

.FeatureFlagsScreen-module__p-b-20___vSkvA {
  padding-bottom: 20px !important;
}

.FeatureFlagsScreen-module__p-b-25___LskO7 {
  padding-bottom: 25px !important;
}

.FeatureFlagsScreen-module__p-b-30___vY5Kd {
  padding-bottom: 30px !important;
}

.FeatureFlagsScreen-module__p-b-50___mNAHS {
  padding-bottom: 50px !important;
}

.FeatureFlagsScreen-module__p-t-0____6tpl {
  padding-top: 0 !important;
}

.FeatureFlagsScreen-module__p-t-12___U631A {
  padding-top: 12px !important;
}

.FeatureFlagsScreen-module__p-t-16___WFF6t {
  padding-top: 16px !important;
}

.FeatureFlagsScreen-module__p-t-18___PBmui {
  padding-top: 18px !important;
}

.FeatureFlagsScreen-module__p-t-20___A_MFy {
  padding-top: 20px !important;
}

.FeatureFlagsScreen-module__p-t-30___cFtHC {
  padding-top: 30px !important;
}

.FeatureFlagsScreen-module__p-t-40___cR2gM {
  padding-top: 40px !important;
}

.FeatureFlagsScreen-module__p-t-50___UzlMH {
  padding-top: 50px !important;
}

.FeatureFlagsScreen-module__p-l-20___ChJ7U {
  padding-left: 20px !important;
}

.FeatureFlagsScreen-module__p-l-30___THVGQ {
  padding-left: 30px !important;
}

.FeatureFlagsScreen-module__p-l-40___lhBF1 {
  padding-left: 40px !important;
}

.FeatureFlagsScreen-module__p-r-16___EySLO {
  padding-right: 16px !important;
}

.FeatureFlagsScreen-module__p-r-20___MGQjD {
  padding-right: 20px !important;
}

.FeatureFlagsScreen-module__p-r-30____zjjy {
  padding-right: 30px !important;
}

.FeatureFlagsScreen-module__p-r-50___XRkwi {
  padding-right: 50px !important;
}

.FeatureFlagsScreen-module__p-r-60___ujlq1 {
  padding-right: 60px !important;
}

.FeatureFlagsScreen-module__m-b-1___cjrKC {
  margin-bottom: 1px !important;
}

.FeatureFlagsScreen-module__m-b-2___gPN6v {
  margin-bottom: 2px !important;
}

.FeatureFlagsScreen-module__m-b-6___pBNpY {
  margin-bottom: 6px !important;
}

.FeatureFlagsScreen-module__m-b-8___LNLhm {
  margin-bottom: 8px !important;
}

.FeatureFlagsScreen-module__m-b-10___sY6UF {
  margin-bottom: 10px !important;
}

.FeatureFlagsScreen-module__m-b-14___ZlWDf {
  margin-bottom: 14px !important;
}

.FeatureFlagsScreen-module__m-b-16___rXjgB {
  margin-bottom: 16px !important;
}

.FeatureFlagsScreen-module__m-b-20___CISC0 {
  margin-bottom: 20px !important;
}

.FeatureFlagsScreen-module__m-b-22___AisCV {
  margin-bottom: 22px !important;
}

.FeatureFlagsScreen-module__m-b-24___RNgbb {
  margin-bottom: 24px !important;
}

.FeatureFlagsScreen-module__m-b-30___jgpXy {
  margin-bottom: 30px !important;
}

.FeatureFlagsScreen-module__m-b-32___tktiF {
  margin-bottom: 32px !important;
}

.FeatureFlagsScreen-module__m-b-40___Lxmnv {
  margin-bottom: 40px !important;
}

.FeatureFlagsScreen-module__m-t-2___FsmEM {
  margin-top: 2px !important;
}

.FeatureFlagsScreen-module__m-t-3___jopEl {
  margin-top: 3px !important;
}

.FeatureFlagsScreen-module__m-t-4____6Sj5 {
  margin-top: 4px !important;
}

.FeatureFlagsScreen-module__m-t-5___cZuSn {
  margin-top: 5px !important;
}

.FeatureFlagsScreen-module__m-t-8___hXPh7 {
  margin-top: 8px !important;
}

.FeatureFlagsScreen-module__m-t-10___Appjh {
  margin-top: 10px !important;
}

.FeatureFlagsScreen-module__m-t-15___NqYlS {
  margin-top: 15px !important;
}

.FeatureFlagsScreen-module__m-t-16___hrB0X {
  margin-top: 16px !important;
}

.FeatureFlagsScreen-module__m-t-20___zt1_j {
  margin-top: 20px !important;
}

.FeatureFlagsScreen-module__m-t-22___EMk_E {
  margin-top: 22px !important;
}

.FeatureFlagsScreen-module__m-t-30___WPKGu {
  margin-top: 30px !important;
}

.FeatureFlagsScreen-module__m-t-32___cO8iq {
  margin-top: 32px !important;
}

.FeatureFlagsScreen-module__m-l-auto___PYtIj {
  margin-left: auto !important;
}

.FeatureFlagsScreen-module__m-l-4___vyE0m {
  margin-left: 4px !important;
}

.FeatureFlagsScreen-module__m-l-5___erOYQ {
  margin-left: 5px !important;
}

.FeatureFlagsScreen-module__m-l-6___Dxu0W {
  margin-left: 6px !important;
}

.FeatureFlagsScreen-module__m-l-8___CoZ81 {
  margin-left: 8px !important;
}

.FeatureFlagsScreen-module__m-l-10___SN1zw {
  margin-left: 10px !important;
}

.FeatureFlagsScreen-module__m-l-16___SMkar {
  margin-left: 16px !important;
}

.FeatureFlagsScreen-module__m-l-20___eAzo8 {
  margin-left: 20px !important;
}

.FeatureFlagsScreen-module__m-l-24___akJcd {
  margin-left: 24px !important;
}

.FeatureFlagsScreen-module__m-l-30___sVoQZ {
  margin-left: 30px !important;
}

.FeatureFlagsScreen-module__m-l-35___WKi_6 {
  margin-left: 35px !important;
}

.FeatureFlagsScreen-module__m-l-40___DKVe5 {
  margin-left: 40px !important;
}

.FeatureFlagsScreen-module__m-r-8___A3YQm {
  margin-right: 8px !important;
}

.FeatureFlagsScreen-module__m-r-10___lwKRW {
  margin-right: 10px !important;
}

.FeatureFlagsScreen-module__m-r-16___dKnt5 {
  margin-right: 16px !important;
}

.FeatureFlagsScreen-module__m-r-20___lYHAS {
  margin-right: 20px !important;
}

.FeatureFlagsScreen-module__m-r-24___LBJbU {
  margin-right: 24px !important;
}

.FeatureFlagsScreen-module__m-r-30___uCpFT {
  margin-right: 30px !important;
}

.FeatureFlagsScreen-module__m-r-40___izs1W {
  margin-right: 40px !important;
}

.FeatureFlagsScreen-module__border-r-3___kcxvR {
  border-radius: 3px !important;
}

.FeatureFlagsScreen-module__border-r-4___vRgyk {
  border-radius: 4px !important;
}

.FeatureFlagsScreen-module__border-r-6___pAkJr {
  border-radius: 6px !important;
}

.FeatureFlagsScreen-module__border-r-10___FtbJn {
  border-radius: 10px !important;
}

.FeatureFlagsScreen-module__border-r-12___iw88w {
  border-radius: 12px !important;
}

.FeatureFlagsScreen-module__border-r-16___ZSkDf {
  border-radius: 16px !important;
}

.FeatureFlagsScreen-module__border-r-50___bqFKp {
  border-radius: 50% !important;
}

.FeatureFlagsScreen-module__primary-border___YZVig {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagsScreen-module__primary-border-b___IteeV {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagsScreen-module__primary-border-t___p_F2z {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagsScreen-module__primary-border-l___H4Suz {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagsScreen-module__primary-border-r___rhv_Q {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagsScreen-module__secondary-border___HRIYQ {
  border: 1px solid #637768;
}

.FeatureFlagsScreen-module__secondary-border-b___IIoDY {
  border-bottom: 1px solid #637768;
}

.FeatureFlagsScreen-module__secondary-border-t___Ie9Ik {
  border-top: 1px solid #637768;
}

.FeatureFlagsScreen-module__secondary-border-l___x6qhL {
  border-left: 1px solid #637768;
}

.FeatureFlagsScreen-module__secondary-border-r___Q46H_ {
  border-right: 1px solid #637768;
}

.FeatureFlagsScreen-module__gap-0___EZSzJ {
  gap: 0 !important;
}

.FeatureFlagsScreen-module__gap-2___oOr5G {
  gap: 2px !important;
}

.FeatureFlagsScreen-module__gap-4___n_vHK {
  gap: 4px !important;
}

.FeatureFlagsScreen-module__gap-5___qgmFO {
  gap: 5px !important;
}

.FeatureFlagsScreen-module__gap-6___pJAhm {
  gap: 6px !important;
}

.FeatureFlagsScreen-module__gap-8___cMyYc {
  gap: 8px !important;
}

.FeatureFlagsScreen-module__gap-10___dYta0 {
  gap: 10px !important;
}

.FeatureFlagsScreen-module__gap-12___MDCDG {
  gap: 12px !important;
}

.FeatureFlagsScreen-module__gap-14___Np_oc {
  gap: 14px !important;
}

.FeatureFlagsScreen-module__gap-16___WcfCe {
  gap: 16px !important;
}

.FeatureFlagsScreen-module__gap-18___MUcNY {
  gap: 18px !important;
}

.FeatureFlagsScreen-module__gap-20___AVNIM {
  gap: 20px !important;
}

.FeatureFlagsScreen-module__gap-24___wP_xD {
  gap: 24px !important;
}

.FeatureFlagsScreen-module__gap-26___nnE69 {
  gap: 26px !important;
}

.FeatureFlagsScreen-module__gap-30___pfeXE {
  gap: 30px !important;
}

.FeatureFlagsScreen-module__gap-32___HW68j {
  gap: 32px !important;
}

.FeatureFlagsScreen-module__gap-40___qR7Zz {
  gap: 40px !important;
}

.FeatureFlagsScreen-module__gap-50___feMcb {
  gap: 50px !important;
}

.FeatureFlagsScreen-module__flex-1___hetwV {
  flex: 1;
}

.FeatureFlagsScreen-module__flex-none___XdMNr {
  flex: none !important;
}

.FeatureFlagsScreen-module__flex-column___zWyYz {
  display: flex;
  flex-direction: column !important;
}

.FeatureFlagsScreen-module__flex-row___XEDGY {
  display: flex;
  flex-direction: row !important;
}

.FeatureFlagsScreen-module__vertically-centered___xZOtG {
  display: flex;
  align-items: center !important;
}

.FeatureFlagsScreen-module__horizontally-centered___s6oWB {
  display: flex;
  justify-content: center !important;
}

.FeatureFlagsScreen-module__horizontally-end___nkmC8 {
  display: flex;
  justify-content: end !important;
}

.FeatureFlagsScreen-module__vertically-start___w_3LY {
  display: flex;
  align-items: start !important;
}

.FeatureFlagsScreen-module__space-between___rHYO4 {
  display: flex;
  justify-content: space-between !important;
}

.FeatureFlagsScreen-module__flex-wrap___Lz1YV {
  flex-wrap: wrap !important;
}

.FeatureFlagsScreen-module__height-100____sdCs {
  height: 100%;
}

.FeatureFlagsScreen-module__width-50___qgFLd {
  width: 50% !important;
}

.FeatureFlagsScreen-module__width-100___cy2zd {
  width: 100%;
}

.FeatureFlagsScreen-module__cursor-pointer___tlys3 {
  cursor: pointer;
}

.FeatureFlagsScreen-module__cursor-not-allowed___xXqJQ {
  cursor: not-allowed !important;
}

.FeatureFlagsScreen-module__absolute-centered___HRSAK {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.FeatureFlagsScreen-module__absolute___LirGG {
  position: absolute;
}

.FeatureFlagsScreen-module__relative___dWVw2 {
  position: relative;
}

.FeatureFlagsScreen-module__fixed___bzlZO {
  position: fixed;
}

.FeatureFlagsScreen-module__visible___W0dsZ {
  opacity: 1;
}

.FeatureFlagsScreen-module__invisible___f4QgV {
  opacity: 0;
}

.FeatureFlagsScreen-module__col-90____hSIQ {
  width: 90% !important;
}

.FeatureFlagsScreen-module__col-auto___Bk6ot {
  width: auto !important;
}

.FeatureFlagsScreen-module__medical-tabs___SEMlS {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.FeatureFlagsScreen-module__medical-table-new___VoR38 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FeatureFlagsScreen-module__medical-table-new___VoR38:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FeatureFlagsScreen-module__medical-table-new___VoR38::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FeatureFlagsScreen-module__medical-table-new___VoR38::-webkit-scrollbar-track {
  display: none;
}
.FeatureFlagsScreen-module__medical-table-new___VoR38.FeatureFlagsScreen-module__no-pagination___LtsZr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FeatureFlagsScreen-module__medical-table-new___VoR38.FeatureFlagsScreen-module__no-pagination___LtsZr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FeatureFlagsScreen-module__medical-table-new___VoR38.FeatureFlagsScreen-module__no-pagination___LtsZr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FeatureFlagsScreen-module__medical-table-new___VoR38.FeatureFlagsScreen-module__no-pagination___LtsZr::-webkit-scrollbar-track {
  display: none;
}

.FeatureFlagsScreen-module__medical-table-empty___BIrS_ {
  padding: 14px 40px !important;
}

.FeatureFlagsScreen-module__icon-btn___YKCmW {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.FeatureFlagsScreen-module__search-icon___nWKno {
  width: 24px;
  height: 24px;
  align-self: center;
}

.FeatureFlagsScreen-module__disable-select___TVutH {
  user-select: none;
}

.FeatureFlagsScreen-module__break-word___n_wSa {
  word-break: break-word;
}

.FeatureFlagsScreen-module__popup-clear-btn___NfXru {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.FeatureFlagsScreen-module__scroll-m-b-20___zkLH1 {
  scroll-margin-bottom: 20px;
}

.FeatureFlagsScreen-module__container___TYBFg {
  flex: 1;
  position: relative;
  overflow-y: auto;
  height: calc(100vh - var(--top-navigation) - 62px);
}
.FeatureFlagsScreen-module__container___TYBFg .FeatureFlagsScreen-module__headerContainer___CpBg2 {
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin: 2em 20px;
}
.FeatureFlagsScreen-module__container___TYBFg .FeatureFlagsScreen-module__headerContainer___CpBg2 .FeatureFlagsScreen-module__text___tDDbZ {
  font-family: var(--font-family);
  font-weight: 400;
  color: #375844;
}
.FeatureFlagsScreen-module__container___TYBFg .FeatureFlagsScreen-module__progress___kpjb2 {
  top: 25%;
  left: 50%;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/screens/FeatureFlagsScreen/FeatureFlagsScreen.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AA8pBJ;AA5pBI;EEYF,+BApBO;EAqBP,gBAFmD;EFT/C,cAAA;AA+pBN;AA3pBE;EACE,QAAA;EACA,SAAA;EACA,kBAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  position: relative;\n  overflow-y: auto;\n  height: calc(100vh - var(--top-navigation) - #{$settings-header});\n\n  .headerContainer {\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 2em 20px;\n\n    .text {\n      @include get-font();\n      color: get-color(greenNew, dark);\n    }\n  }\n\n  .progress {\n    top: 25%;\n    left: 50%;\n    position: absolute;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `FeatureFlagsScreen-module__font-s-10___gFfOf`,
	"fontS12": `FeatureFlagsScreen-module__font-s-12___NvfAf`,
	"fontS13": `FeatureFlagsScreen-module__font-s-13___rVf6z`,
	"fontS14": `FeatureFlagsScreen-module__font-s-14___S0bU2`,
	"fontS15": `FeatureFlagsScreen-module__font-s-15___IYReO`,
	"fontS16": `FeatureFlagsScreen-module__font-s-16___lTG2S`,
	"fontS18": `FeatureFlagsScreen-module__font-s-18___lQnAO`,
	"fontS20": `FeatureFlagsScreen-module__font-s-20___xhJ8y`,
	"fontS22": `FeatureFlagsScreen-module__font-s-22___nBeKW`,
	"fontS28": `FeatureFlagsScreen-module__font-s-28___f0OKw`,
	"fontW400": `FeatureFlagsScreen-module__font-w-400___eevkE`,
	"fontW500": `FeatureFlagsScreen-module__font-w-500___fmyhp`,
	"fontW600": `FeatureFlagsScreen-module__font-w-600____Kkwe`,
	"fontW700": `FeatureFlagsScreen-module__font-w-700___ofS4c`,
	"p5": `FeatureFlagsScreen-module__p-5___gZBOy`,
	"p12": `FeatureFlagsScreen-module__p-12___ywtnW`,
	"p16": `FeatureFlagsScreen-module__p-16___zOLPi`,
	"p30": `FeatureFlagsScreen-module__p-30___iZi_x`,
	"pB0": `FeatureFlagsScreen-module__p-b-0___hXbj_`,
	"pB5": `FeatureFlagsScreen-module__p-b-5___G8CpD`,
	"pB10": `FeatureFlagsScreen-module__p-b-10___BBGZO`,
	"pB12": `FeatureFlagsScreen-module__p-b-12___TSAvn`,
	"pB16": `FeatureFlagsScreen-module__p-b-16___Bv6Kb`,
	"pB18": `FeatureFlagsScreen-module__p-b-18___iQ_Lw`,
	"pB20": `FeatureFlagsScreen-module__p-b-20___vSkvA`,
	"pB25": `FeatureFlagsScreen-module__p-b-25___LskO7`,
	"pB30": `FeatureFlagsScreen-module__p-b-30___vY5Kd`,
	"pB50": `FeatureFlagsScreen-module__p-b-50___mNAHS`,
	"pT0": `FeatureFlagsScreen-module__p-t-0____6tpl`,
	"pT12": `FeatureFlagsScreen-module__p-t-12___U631A`,
	"pT16": `FeatureFlagsScreen-module__p-t-16___WFF6t`,
	"pT18": `FeatureFlagsScreen-module__p-t-18___PBmui`,
	"pT20": `FeatureFlagsScreen-module__p-t-20___A_MFy`,
	"pT30": `FeatureFlagsScreen-module__p-t-30___cFtHC`,
	"pT40": `FeatureFlagsScreen-module__p-t-40___cR2gM`,
	"pT50": `FeatureFlagsScreen-module__p-t-50___UzlMH`,
	"pL20": `FeatureFlagsScreen-module__p-l-20___ChJ7U`,
	"pL30": `FeatureFlagsScreen-module__p-l-30___THVGQ`,
	"pL40": `FeatureFlagsScreen-module__p-l-40___lhBF1`,
	"pR16": `FeatureFlagsScreen-module__p-r-16___EySLO`,
	"pR20": `FeatureFlagsScreen-module__p-r-20___MGQjD`,
	"pR30": `FeatureFlagsScreen-module__p-r-30____zjjy`,
	"pR50": `FeatureFlagsScreen-module__p-r-50___XRkwi`,
	"pR60": `FeatureFlagsScreen-module__p-r-60___ujlq1`,
	"mB1": `FeatureFlagsScreen-module__m-b-1___cjrKC`,
	"mB2": `FeatureFlagsScreen-module__m-b-2___gPN6v`,
	"mB6": `FeatureFlagsScreen-module__m-b-6___pBNpY`,
	"mB8": `FeatureFlagsScreen-module__m-b-8___LNLhm`,
	"mB10": `FeatureFlagsScreen-module__m-b-10___sY6UF`,
	"mB14": `FeatureFlagsScreen-module__m-b-14___ZlWDf`,
	"mB16": `FeatureFlagsScreen-module__m-b-16___rXjgB`,
	"mB20": `FeatureFlagsScreen-module__m-b-20___CISC0`,
	"mB22": `FeatureFlagsScreen-module__m-b-22___AisCV`,
	"mB24": `FeatureFlagsScreen-module__m-b-24___RNgbb`,
	"mB30": `FeatureFlagsScreen-module__m-b-30___jgpXy`,
	"mB32": `FeatureFlagsScreen-module__m-b-32___tktiF`,
	"mB40": `FeatureFlagsScreen-module__m-b-40___Lxmnv`,
	"mT2": `FeatureFlagsScreen-module__m-t-2___FsmEM`,
	"mT3": `FeatureFlagsScreen-module__m-t-3___jopEl`,
	"mT4": `FeatureFlagsScreen-module__m-t-4____6Sj5`,
	"mT5": `FeatureFlagsScreen-module__m-t-5___cZuSn`,
	"mT8": `FeatureFlagsScreen-module__m-t-8___hXPh7`,
	"mT10": `FeatureFlagsScreen-module__m-t-10___Appjh`,
	"mT15": `FeatureFlagsScreen-module__m-t-15___NqYlS`,
	"mT16": `FeatureFlagsScreen-module__m-t-16___hrB0X`,
	"mT20": `FeatureFlagsScreen-module__m-t-20___zt1_j`,
	"mT22": `FeatureFlagsScreen-module__m-t-22___EMk_E`,
	"mT30": `FeatureFlagsScreen-module__m-t-30___WPKGu`,
	"mT32": `FeatureFlagsScreen-module__m-t-32___cO8iq`,
	"mLAuto": `FeatureFlagsScreen-module__m-l-auto___PYtIj`,
	"mL4": `FeatureFlagsScreen-module__m-l-4___vyE0m`,
	"mL5": `FeatureFlagsScreen-module__m-l-5___erOYQ`,
	"mL6": `FeatureFlagsScreen-module__m-l-6___Dxu0W`,
	"mL8": `FeatureFlagsScreen-module__m-l-8___CoZ81`,
	"mL10": `FeatureFlagsScreen-module__m-l-10___SN1zw`,
	"mL16": `FeatureFlagsScreen-module__m-l-16___SMkar`,
	"mL20": `FeatureFlagsScreen-module__m-l-20___eAzo8`,
	"mL24": `FeatureFlagsScreen-module__m-l-24___akJcd`,
	"mL30": `FeatureFlagsScreen-module__m-l-30___sVoQZ`,
	"mL35": `FeatureFlagsScreen-module__m-l-35___WKi_6`,
	"mL40": `FeatureFlagsScreen-module__m-l-40___DKVe5`,
	"mR8": `FeatureFlagsScreen-module__m-r-8___A3YQm`,
	"mR10": `FeatureFlagsScreen-module__m-r-10___lwKRW`,
	"mR16": `FeatureFlagsScreen-module__m-r-16___dKnt5`,
	"mR20": `FeatureFlagsScreen-module__m-r-20___lYHAS`,
	"mR24": `FeatureFlagsScreen-module__m-r-24___LBJbU`,
	"mR30": `FeatureFlagsScreen-module__m-r-30___uCpFT`,
	"mR40": `FeatureFlagsScreen-module__m-r-40___izs1W`,
	"borderR3": `FeatureFlagsScreen-module__border-r-3___kcxvR`,
	"borderR4": `FeatureFlagsScreen-module__border-r-4___vRgyk`,
	"borderR6": `FeatureFlagsScreen-module__border-r-6___pAkJr`,
	"borderR10": `FeatureFlagsScreen-module__border-r-10___FtbJn`,
	"borderR12": `FeatureFlagsScreen-module__border-r-12___iw88w`,
	"borderR16": `FeatureFlagsScreen-module__border-r-16___ZSkDf`,
	"borderR50": `FeatureFlagsScreen-module__border-r-50___bqFKp`,
	"primaryBorder": `FeatureFlagsScreen-module__primary-border___YZVig`,
	"primaryBorderB": `FeatureFlagsScreen-module__primary-border-b___IteeV`,
	"primaryBorderT": `FeatureFlagsScreen-module__primary-border-t___p_F2z`,
	"primaryBorderL": `FeatureFlagsScreen-module__primary-border-l___H4Suz`,
	"primaryBorderR": `FeatureFlagsScreen-module__primary-border-r___rhv_Q`,
	"secondaryBorder": `FeatureFlagsScreen-module__secondary-border___HRIYQ`,
	"secondaryBorderB": `FeatureFlagsScreen-module__secondary-border-b___IIoDY`,
	"secondaryBorderT": `FeatureFlagsScreen-module__secondary-border-t___Ie9Ik`,
	"secondaryBorderL": `FeatureFlagsScreen-module__secondary-border-l___x6qhL`,
	"secondaryBorderR": `FeatureFlagsScreen-module__secondary-border-r___Q46H_`,
	"gap0": `FeatureFlagsScreen-module__gap-0___EZSzJ`,
	"gap2": `FeatureFlagsScreen-module__gap-2___oOr5G`,
	"gap4": `FeatureFlagsScreen-module__gap-4___n_vHK`,
	"gap5": `FeatureFlagsScreen-module__gap-5___qgmFO`,
	"gap6": `FeatureFlagsScreen-module__gap-6___pJAhm`,
	"gap8": `FeatureFlagsScreen-module__gap-8___cMyYc`,
	"gap10": `FeatureFlagsScreen-module__gap-10___dYta0`,
	"gap12": `FeatureFlagsScreen-module__gap-12___MDCDG`,
	"gap14": `FeatureFlagsScreen-module__gap-14___Np_oc`,
	"gap16": `FeatureFlagsScreen-module__gap-16___WcfCe`,
	"gap18": `FeatureFlagsScreen-module__gap-18___MUcNY`,
	"gap20": `FeatureFlagsScreen-module__gap-20___AVNIM`,
	"gap24": `FeatureFlagsScreen-module__gap-24___wP_xD`,
	"gap26": `FeatureFlagsScreen-module__gap-26___nnE69`,
	"gap30": `FeatureFlagsScreen-module__gap-30___pfeXE`,
	"gap32": `FeatureFlagsScreen-module__gap-32___HW68j`,
	"gap40": `FeatureFlagsScreen-module__gap-40___qR7Zz`,
	"gap50": `FeatureFlagsScreen-module__gap-50___feMcb`,
	"flex1": `FeatureFlagsScreen-module__flex-1___hetwV`,
	"flexNone": `FeatureFlagsScreen-module__flex-none___XdMNr`,
	"flexColumn": `FeatureFlagsScreen-module__flex-column___zWyYz`,
	"flexRow": `FeatureFlagsScreen-module__flex-row___XEDGY`,
	"verticallyCentered": `FeatureFlagsScreen-module__vertically-centered___xZOtG`,
	"horizontallyCentered": `FeatureFlagsScreen-module__horizontally-centered___s6oWB`,
	"horizontallyEnd": `FeatureFlagsScreen-module__horizontally-end___nkmC8`,
	"verticallyStart": `FeatureFlagsScreen-module__vertically-start___w_3LY`,
	"spaceBetween": `FeatureFlagsScreen-module__space-between___rHYO4`,
	"flexWrap": `FeatureFlagsScreen-module__flex-wrap___Lz1YV`,
	"height100": `FeatureFlagsScreen-module__height-100____sdCs`,
	"width50": `FeatureFlagsScreen-module__width-50___qgFLd`,
	"width100": `FeatureFlagsScreen-module__width-100___cy2zd`,
	"cursorPointer": `FeatureFlagsScreen-module__cursor-pointer___tlys3`,
	"cursorNotAllowed": `FeatureFlagsScreen-module__cursor-not-allowed___xXqJQ`,
	"absoluteCentered": `FeatureFlagsScreen-module__absolute-centered___HRSAK`,
	"absolute": `FeatureFlagsScreen-module__absolute___LirGG`,
	"relative": `FeatureFlagsScreen-module__relative___dWVw2`,
	"fixed": `FeatureFlagsScreen-module__fixed___bzlZO`,
	"visible": `FeatureFlagsScreen-module__visible___W0dsZ`,
	"invisible": `FeatureFlagsScreen-module__invisible___f4QgV`,
	"col90": `FeatureFlagsScreen-module__col-90____hSIQ`,
	"colAuto": `FeatureFlagsScreen-module__col-auto___Bk6ot`,
	"medicalTabs": `FeatureFlagsScreen-module__medical-tabs___SEMlS`,
	"medicalTableNew": `FeatureFlagsScreen-module__medical-table-new___VoR38`,
	"noPagination": `FeatureFlagsScreen-module__no-pagination___LtsZr`,
	"medicalTableEmpty": `FeatureFlagsScreen-module__medical-table-empty___BIrS_`,
	"iconBtn": `FeatureFlagsScreen-module__icon-btn___YKCmW`,
	"searchIcon": `FeatureFlagsScreen-module__search-icon___nWKno`,
	"disableSelect": `FeatureFlagsScreen-module__disable-select___TVutH`,
	"breakWord": `FeatureFlagsScreen-module__break-word___n_wSa`,
	"popupClearBtn": `FeatureFlagsScreen-module__popup-clear-btn___NfXru`,
	"scrollMB20": `FeatureFlagsScreen-module__scroll-m-b-20___zkLH1`,
	"container": `FeatureFlagsScreen-module__container___TYBFg`,
	"headerContainer": `FeatureFlagsScreen-module__headerContainer___CpBg2`,
	"text": `FeatureFlagsScreen-module__text___tDDbZ`,
	"progress": `FeatureFlagsScreen-module__progress___kpjb2`
};
module.exports = ___CSS_LOADER_EXPORT___;
